const constants = {
  DEPARTMENT_DIMENSION_NAME: 'Store.Department',
  DEPARTMENT_OOS_DIMENSION_NAMES: ['childSKUs.hideOutOfStock', 'outOfStock'],
  DEPARTMENT_NAME_MODIFICATION: 'Select a Department',
  AGE_RANGE_DIMENSION_NAME: 'babykidsclothingsize',
  AGE_RANGE_MODIFICATION: 'Age Range',
  BRAND_DIMENSION_NAME: 'brand',
  WOMENS_SIZE_DIMENSION_NAME: 'womensclothingsize',
  WOMENS_SIZE_MODIFICATION: 'Size',
  MENS_SIZE_DIMENSION_NAME: 'mensclothingsize',
  MENS_SIZE_MODIFICATION: 'Size',
  XXS_MOBILE_MAX_WIDTH: 375,
  XS_MOBILE_MAX_WIDTH: 568,
  MOBILE_MAX_WIDTH: 768,
  TABLET_MAX_WIDTH: 1023,
  MAX_COMPARE_DESKTOP: 4,
  MAX_COMPARE_MOBILE: 3,
  MAX_OPTIONS_TO_SHOW: 9,
  FASHION_SIZE_DIMENSION_NAMES: ['fashionsize', 'FashionSize'],
  COMPARE_LOCAL_STORAGE_KEY: 'compare:data',
  PLP_VIEW_TYPES: {
    GRID: 'grid',
    LIST: 'list',
  },
  PLP_CARD_SIZES: {
    SMALL: 'small',
    LARGE: 'large',
  },
  STORAGE_TYPES: {
    COOKIES: 'cookie',
    LOCAL_STORAGE: 'localStorage',
    SESSION_STORAGE: 'sessionStorage',
  },
  NVAL_REGEX: /\/(?:_\/)(N-[0-9a-zA-Z]+[0-9a-zA-Y])$/,
  OMITTED_FACET_DIMENSIONS: ['childSKUs.hideOutOfStock', 'sku.offerType'],
};

export default constants;
